import { render, staticRenderFns } from "./PatientReportForm.vue?vue&type=template&id=4265f2e7&scoped=true&"
import script from "./PatientReportForm.vue?vue&type=script&lang=js&"
export * from "./PatientReportForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientReportForm.vue?vue&type=style&index=0&id=4265f2e7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4265f2e7",
  null
  
)

export default component.exports